
import moment from 'moment';
import {
  Component, Mixins, Watch,
} from 'vue-property-decorator';
import DatePickerDialog from '@/components/DatePickerDialog.vue';
import AttachmentWithStatus from '@/components/AttachmentWithStatus.vue';
import {
  getLeadCustomValueText,
  getLeadCustomValueDate,
} from '@/helpers';
import { AttachmentType, BoxStatusType, Lead } from '@/types';
import UtilsMixin from '@/mixins/UtilsMixin.vue';
import CurrentSupply from '@/components/CurrentSupply.vue';
import AttachmentsList from '@/components/AttachmentsList.vue';
import EditConnectionDialogMixin from '@/mixins/EditConnectionDialogMixin.vue';
import SupplyAlertDialog from '@/components/SupplyAlertDialog.vue';
import EditLeadSupplyDialog from '@/components/EditLeadSupplyDialog.vue';

moment.locale('it');

@Component({
  components: {
    DatePickerDialog,
    CurrentSupply,
    AttachmentsList,
    AttachmentWithStatus,
    SupplyAlertDialog,
    EditLeadSupplyDialog,
  },
})
// eslint-disable-next-line max-len
export default class EditConnectionPlanDialog extends Mixins(EditConnectionDialogMixin, UtilsMixin) {
  supplyAlertDialog = false
  editSupplyDialog = false

  // Il form è valido?
  isFormValid = false

  progettoElettrico: BoxStatusType = 'todo'

  ePlanDate: Date | null = null;
  ePlanDoneDate: Date | null = null;
  ePlanDateViewMode: string | null | undefined = null

  progettoElettricoNotes: string | null | undefined = null
  powerDetails1: string | null | undefined = null
  powerDetails2: string | null | undefined = null
  powerDetails3: string | null | undefined = null
  powerDetails4: string | null | undefined = null
  powerDetails5: string | null | undefined = null

  // Aggiorna i campi con gli eventuali nuovi valori della Connection/Lead selezionata
  refresh() {
    console.log(`${this.constructor.name}: refresh()`); // eslint-disable-line no-console

    // Svuota i dati nell'attesa che sia caricata la figlia elettrica
    this.ePlanDate = null;
    this.ePlanDoneDate = null;
    this.ePlanDateViewMode = 'week';

    this.progettoElettrico = 'todo';
    this.progettoElettricoNotes = null;

    this.powerDetails1 = null;
    this.powerDetails2 = null;
    this.powerDetails3 = null;
    this.powerDetails4 = null;
    this.powerDetails5 = null;

    // Richiama il metodo del mixin
    return this.mixinRefresh();
  }

  initialPickerMode(): string | null | undefined {
    return this.ePlanDateViewMode;
  }

  planDateString(date: Date | null | undefined): string | null {
    return this.ePlanDateViewMode === 'week' ? this.mWeek(date) : this.mDate(date);
  }

  updateAttachmentStatus(type: AttachmentType, status: BoxStatusType) {
    console.log(`${this.constructor.name}: updateAttachmentStatus(${type}, ${status})`); // eslint-disable-line no-console

    // Se lo stato non è uno di quelli gestiti, si ferma subito
    if (type in this === false) { return; }

    (this[type] as BoxStatusType) = status;

    const update = {} as { [key: string]: unknown };

    update[type] = status;

    // Aggiorno i campi collegati
    if (this.progettoElettrico === 'done') {
      this.ePlanDoneDate = moment(moment(), 'YYYY-MM-DD').toDate();
      update.ePlanDoneDate = this.ePlanDoneDate;
    } else {
      this.ePlanDoneDate = null;
      update.ePlanDoneDate = null;
    }

    this.$store.dispatch('updateConnectionFields', {
      fields: update,
    });
  }

  onClickDate(name: string) {
    console.log(`${this.constructor.name}: onClickDate(${name})`); // eslint-disable-line no-console

    // Imposta per quale campo verrà utilizzato il DatePicker
    this.datePickerName = name;

    // Imposta l'eventuale data precedentemente selezionata
    this.datePickerDate = this[name]
      ? moment(this[name]).toISOString(true).substring(0, 10)
      : null;

    // Apre il dialog per la selezione della data o della settimana
    this.weekPickerDialog = true;
  }

  @Watch('currentElettricaFiglia')
  onCurrentElettricaFigliaChange(val: Lead | null, oldVal: Lead | null) {
    if (oldVal === null && val !== null) {
      this.ePlanDate = getLeadCustomValueDate(this.currentElettricaFiglia, 'ePlanDate');
      this.ePlanDoneDate = getLeadCustomValueDate(this.currentElettricaFiglia, 'ePlanDoneDate');
      this.ePlanDateViewMode = getLeadCustomValueText(this.currentElettricaFiglia, 'ePlanDateViewMode') ?? 'week';

      this.progettoElettrico = (getLeadCustomValueText(this.currentElettricaFiglia, 'progettoElettrico') ?? 'todo') as BoxStatusType;
      this.progettoElettricoNotes = getLeadCustomValueText(this.currentElettricaFiglia, 'progettoElettricoNotes');

      this.powerDetails1 = getLeadCustomValueText(this.currentElettricaFiglia, 'powerDetails1');
      this.powerDetails2 = getLeadCustomValueText(this.currentElettricaFiglia, 'powerDetails2');
      this.powerDetails3 = getLeadCustomValueText(this.currentElettricaFiglia, 'powerDetails3');
      this.powerDetails4 = getLeadCustomValueText(this.currentElettricaFiglia, 'powerDetails4');
      this.powerDetails5 = getLeadCustomValueText(this.currentElettricaFiglia, 'powerDetails5');
    }
  }
}
